import { useCallback, useEffect } from 'react'

import { useSelector } from 'react-redux'

import { useLazyGetProfileQuery } from '@web/entities/user/api/profile.api'
import { selectAuthStatus } from '@web/entities/user/model/auth.selector'
import { EAuthStatus } from '@web/shared/enums/auth/auth-status.enum'
import { useAppSelector } from '@web/shared/utils/use-app-selector.util'

import { useAuthActions } from '../model/auth.slice'


export const useAuthToken = () => {
  const [triggerGetProfile] = useLazyGetProfileQuery()
  const { accessToken } = useAppSelector((state) => state.auth)
  const authStatus = useSelector(selectAuthStatus)

  const { setAuthorized, setLogout } = useAuthActions()

  const loginUserByToken = useCallback(async () => {
    try {
      await triggerGetProfile().unwrap()

      setAuthorized()
    } catch (e) {
      console.error(e)
      setLogout()
    }
  }, [triggerGetProfile, setAuthorized, setLogout])

  useEffect(() => {
    if (authStatus === EAuthStatus.AUTHORIZED) return
    if (!accessToken) {
      setLogout()
      return
    }

    loginUserByToken()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { authStatus }
}
